import { combineReducers } from 'redux';
import SessionReducers, { RestoreState as SessionRestoreState } from './Session';
import ProfileReducers, { RestoreState as ProfileRestoreState} from './Profile';
import PreferencesReducers, { RestoreState as PreferencesRestoreStore } from './Preferences';

const initialState = {
    session: null
};

SessionRestoreState(initialState);
ProfileRestoreState(initialState);
PreferencesRestoreStore(initialState);

const ReducerSwitch = {};
SessionReducers(ReducerSwitch);
ProfileReducers(ReducerSwitch);
PreferencesReducers(ReducerSwitch);

const rootReducer = (prevState = initialState, action) => {
    if (ReducerSwitch[action.type]) {
        return ReducerSwitch[action.type](prevState, action);
    }
    return prevState;
};

// const rootReducer = combineReducers({
//     reducer
// });

export default rootReducer;